// utils/browserUtils.js
// Utility for opening links with Capacitor Browser plugin support

import { Browser } from '@capacitor/browser';

/**
 * Opens a URL using Capacitor Browser plugin if available, 
 * otherwise falls back to window.open
 * 
 * @param {string} link - The URL to open
 * @param {string} target - Target for window.open fallback (default: '_blank')
 */
export const openCapacitorSite = async (link, target = '_blank') => {
  if (!link) return;
  
  try {
    if (Browser) {
      await Browser.open({ url: link });
    } else {
      window.open(link, target);
    }
  } catch (error) {
    // Fallback for any errors
    window.open(link, target);
  }
};

/**
 * Opens a URL in the same window (for internal navigation)
 * Uses window.open with '_self' target
 * 
 * @param {string} link - The URL to open
 */
export const openInSameWindow = (link) => {
  if (!link) return;
  window.open(link, '_self');
};

export default openCapacitorSite;